<template>
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main">
      <div class="left" :style="'height:' + screenHeight">
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>累计处理</div>
            <div>
              <el-date-picker
                v-model="valueLeftTop"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <div style="margin-top: 30px; padding-left: 20px">
            当前累计拆卸量：3147台
          </div>
          <div class="left-echarts-1" id="left-echarts-1"></div>
        </div>
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>年度处理量</div>
            <div style="width: 100px">
              <el-select v-model="valueLeftBottom" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="left-echarts-2" id="left-echarts-2"></div>
        </div>
      </div>
      <div class="middle" :style="'height:' + screenHeight">
        <div class="middle-content">
          <div class="type-title">
            <div>拆解信息</div>
            <div>
              <el-date-picker
                v-model="valueLeftTop"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="middle-top-box">
            <div class="top-box-item">
              <div class="item-title">
                <img
                  class="img"
                  src="@/assets/images/right-icon1.png"
                  alt=""
                  srcset=""
                />
                <span>回收量</span>
              </div>
              <div class="item-content">
                <div class="item">3752 <span class="itemspan">台</span></div>
                <div class="item">5667 <span class="itemspan">吨</span></div>
              </div>
            </div>
            <div class="top-box-item">
              <div class="item-title">
                <img
                  class="img"
                  src="@/assets/images/right-icon2.png"
                  alt=""
                  srcset=""
                />
                <span>拆解</span>
              </div>
              <div class="item-content">
                <div class="item">3619 <span class="itemspan">台</span></div>
                <div class="item">5410 <span class="itemspan">吨</span></div>
              </div>
            </div>
          </div>
          <div class="middle-center-box">
            <div class="middle-center-item">
              <div class="title">汽车</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>3173</div>
                  <div>3073</div>
                  <div>100</div>
                </div>
              </div>
            </div>
            <div class="middle-center-item">
              <div class="title">摩托车</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>399</div>
                  <div>349</div>
                  <div>50</div>
                </div>
              </div>
            </div>
            <div class="middle-center-item">
              <div class="title">面包车</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>

            <div class="middle-center-item">
              <div class="title">轿车</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>

            <div class="middle-center-item">
              <div class="title">卡车</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>

            <div class="middle-center-item">
              <div class="title">公交车</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="middle-content" style="padding-bottom: unset">
          <div class="type-title">
            <div>产出物累计：3306吨</div>
            <div>
              <el-date-picker
                v-model="valueLeftTop"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="middle-bottom-box">
            <!-- <div class="bottom-item">
              <div class="title">今日注销</div>
              <div class="info">35台</div>
            </div>
            <div class="bottom-item">
              <div class="title">今日注销</div>
              <div class="info">35台</div>
            </div>
            <div class="bottom-item">
              <div class="title">今日注销</div>
              <div class="info">35台</div>
            </div> -->
            <div id="center-echarts-1" class="center-echarts-1"></div>
          </div>
        </div>
      </div>
      <div class="right" :style="'height:' + screenHeight">
        <!-- <div class="right-content" style="height: 35vh">
          <div class="type-title">
            <div>产出物信息</div>
          </div>
          <div style="margin-top: 30px; padding-left: 20px">
            累计产出：3147吨
          </div>
          <div id="right-echarts-2" class="right-echarts-2"></div>
        </div> -->
        <div class="right-content slip_in_animation" style="height: 15%">
          <div class="type-title">
            <div>车辆注销信息</div>
          </div>
          <div class="right-box">
            <div class="right-box-item">
              <div class="title">今日注销</div>
              <div class="info">14台</div>
            </div>
            <div class="right-box-item">
              <div class="title">本月注销</div>
              <div class="info">417台</div>
            </div>
            <div class="right-box-item">
              <div class="title">本年注销</div>
              <div class="info">4512台</div>
            </div>
          </div>
          <!-- <div id="right-echarts-1" class="right-echarts-1"></div> -->
        </div>
        <div class="right-content slip_in_animation" style="height: 30%">
          <div class="type-title">
            <div>回收件累计产出：12366件</div>
          </div>
          <!-- <div id="right-echarts-1" class="right-echarts-1"></div> -->
          <div class="right-table">
            <div class="right-table-item">
              <div>回收件名称</div>
              <div>数量</div>
            </div>
            <div class="right-table-item">
              <div>轮胎</div>
              <div>1988件</div>
            </div>
            <div class="right-table-item">
              <div>轮毂</div>
              <div>2300件</div>
            </div>
            <div class="right-table-item">
              <div>车灯</div>
              <div>498件</div>
            </div>
            <div class="right-table-item">
              <div>车门</div>
              <div>711件</div>
            </div>
            <div class="right-table-item">
              <div>车窗</div>
              <div>241件</div>
            </div>
          </div>
        </div>
        <div class="right-content slip_in_animation">
          <div class="type-title">
            <div>销售信息</div>
          </div>
          <div id="right-echarts-1" class="right-echarts-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
       valueLeftTop: ["2023-01-01", "2023-05-24"],
      valueRightTop: ["2023-01-01", "2023-05-24"],
      valueLeftBottom: "7",
      options: [
        {
          value: "1",
          label: "2017",
        },
        {
          value: "2",
          label: "2018",
        },
        {
          value: "3",
          label: "2019",
        },
        {
          value: "4",
          label: "2020",
        },
        {
          value: "5",
          label: "2021",
        },

        {
          value: "6",
          label: "2022",
        },
        {
          value: "7",
          label: "2023",
        },
      ],
      valueRightBottom: "7",
      optionsRight: [
        {
          value: "1",
          label: "2017",
        },
        {
          value: "2",
          label: "2018",
        },
        {
          value: "3",
          label: "2019",
        },
        {
          value: "4",
          label: "2020",
        },
        {
          value: "5",
          label: "2021",
        },

        {
          value: "6",
          label: "2022",
        },
        {
          value: "7",
          label: "2023",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsLeftTop();
        this.createdCarEchartsLeftBottom();
        this.createdCarEchartsRightBottom();
        // this.createdCarEchartsRightTop();
        this.createdmiddle1();
      });
    }, 200);
  },
  methods: {
    // 饼图
    createdCarEchartsLeftTop() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        title: {
          subtext: "单位：台",
          left: "right",
          subtextStyle: {
            color: "#FFF",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return (
              params.name +
              ":  " +
              params.data.value +
              "（" +
              params.percent +
              "%）"
            );
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          show: false,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "轿车" },
              { value: 735, name: "公交车" },
              { value: 580, name: "吊车" },
              { value: 484, name: "叉车" },
              { value: 300, name: "货车" },
            ],
            label: {
              color: "#FFF",
              formatter(param) {
                return param.data.value;
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 折线图
    createdCarEchartsLeftBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-2");

      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          show: true,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "5%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["一月", "二月", "三月", "四月", "五月"],
          axisLabel: {
            // interval: 1,
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        series: [
          {
            name: "轿车",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [4, 13, 230, 13, 9],
          },
          {
            name: "公交车",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [22, 82, 300, 24, 90],
          },
          {
            name: "吊车",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [15, 23, 20, 14, 19],
          },
          {
            name: "叉车",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [32, 33, 31, 34, 30],
          },
          {
            name: "货车",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [80, 93, 91, 94, 120],
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 柱形图
    createdCarEchartsRightBottom() {
      var leftEchartsTOP = document.getElementById("right-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      // option = {
      //   tooltip: {
      //     trigger: "axis",
      //     axisPointer: {
      //       type: "shadow",
      //       label: {
      //         show: true,
      //       },
      //     },
      //   },
      //   color: [
      //     "#5470c6",
      //     "#91cc75",
      //     "#fac858",
      //     "#ee6666",
      //     "#73c0de",
      //     "#3ba272",
      //     "#fc8452",
      //     "#9a60b4",
      //     "#ea7ccc",
      //   ],
      //   calculable: true,

      //   legend: {
      //     // show: false,
      //     data: ["Growth", "销售重量（吨）", "销售金额（元）"],
      //     itemGap: 5,
      //     bottom: "bottom",
      //     textStyle: {
      //       fontSize: 12,
      //       color: "#FFFFFF",
      //     },
      //   },
      //   grid: {
      //     top: "6%",
      //     left: "3%",
      //     right: "4%",
      //     bottom: "15%",
      //     containLabel: true,
      //   },
      //   xAxis: [
      //     {
      //       type: "category",
      //       data: [2017, 2018, 2019, 2020, 2021],
      //       axisLabel: {
      //         color: "#fff",
      //       },
      //       axisLine: {
      //       lineStyle: {
      //         // color: "#fff",
      //         color: "#094060",

      //       },
      //     },
      //     },
      //   ],
      //   yAxis: [
      //     {
      //       type: "value",
      //       axisLabel: {
      //         color: "#fff",
      //       },
      //       axisLine: {
      //       lineStyle: {
      //         // color: "#fff",
      //         color: "#094060",

      //       },
      //     },
      //     },
      //   ],
      //   series: [
      //     {
      //       name: "销售重量（吨）",
      //       type: "bar",
      //       data: [223, 659, 1211, 1152, 666],
      //       itemStyle: {
      //         normal: {
      //           label: {
      //             show: true, //开启显示
      //             position: "top", //在上方显示
      //             formatter: function (val) {
      //               if (val.value == 0) {
      //                 return "";
      //               }
      //             },
      //             textStyle: {
      //               //数值样式
      //               color: "white",
      //               fontSize: 12,
      //             },
      //           },
      //         },
      //       },
      //       barGap: "0%",
      //     },
      //     {
      //       name: "销售金额（元）",
      //       type: "bar",
      //       data: [99, 56, 1233, 846, 999],
      //       itemStyle: {
      //         normal: {
      //           label: {
      //             show: true, //开启显示
      //             position: "top", //在上方显示
      //             formatter: function (val) {
      //               if (val.value == 0) {
      //                 return "";
      //               }
      //             },
      //             textStyle: {
      //               //数值样式
      //               color: "white",
      //               fontSize: 12,
      //             },
      //           },
      //         },
      //       },
      //     },
      //   ],
      // };
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        grid: {
          top:'3%',
          left: "3%",
          right: "4%",
          bottom: "11%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["一月", "二月", "三月", "四月", "五月"],
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              color: "#fff",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "销售重量",
            type: "bar",
            barWidth: "60%",
            data: [400, 420, 410, 406, 416],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 柱形图

    createdmiddle1() {
      var leftEchartsTOP = document.getElementById("center-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        grid: {
          top: 15,
          left: 0,
          right: 0,
          bottom: 15,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        calculable: true,

        legend: {
          show: false,
          itemGap: 5,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        xAxis: [
          {
            type: "category",
            data: [
              "铜电机",
              "铝电机",
              "保温材料",
              "废铜",
              "废铁",
              "废铝",
              "塑料",
              "电线电缆",
              "废弃零部件",
              "电路板",
            ],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
            // show: false, // 是否显示坐标轴中的y轴
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            // show: false, // 是否显示坐标轴中的y轴
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
          },
        ],
        series: [
          {
            name: "销售重量（吨）",
            type: "bar",
            data: [223, 659, 2855, 1152, 666, 666, 666, 666, 666, 666],
            barWidth: "50%", //设置柱状图的柱状的宽度

            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "inside",
            // 数据窗口范围的起始百分比
            start: 0,
            // 数据窗口范围的结束百分比
            end: 50,
            // 是否锁定选择区域（或叫做数据窗口）的大小，如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放
            zoomLock: true,

            xAxisIndex: [0],
          },
          // 手柄的icon相关配置
          {
            height: 8,
            bottom: 0,
            textStyle: { color: "#fff" },

            handleIcon:
              "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "80%",
            handleStyle: {
              color: "#fff",
              shadowBlur: 3,
              shadowColor: "rgba(0, 0, 0, 0.6)",
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
  <style scoped>
::-webkit-scrollbar {
  width: 0px;
}

.swiper-pagination-bullet-active {
  background-color: orangered;
}
.iframe {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
.head .title {
  flex: 1;
  color: #fff;
  text-align: center;
  font-size: 32px;
  padding-top: 15px;
}
.head .nowtime {
  color: #fff;
  position: absolute;
  right: 30px;
  top: 30px;
}
.main {
  display: flex;
  align-items: center;
  background: rgba(17, 47, 107, 0.6);
  width: 98.5vw;
  margin: 0 auto;
}
.main .left,
.main .right {
  width: 520px;
  height: 75vh;

  overflow: hidden;
}
.main .left {
  /* float: left; */
  margin-left: 20px;
}
.main .right {
  /* float: right; */
  margin-right: 20px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  height: 50%;
}
::v-deep .main .left .left-content .type-title,
.main .right .right-content .type-title,
.middle-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main .right .right-content {
  padding: 20px;
  color: #fff;
  height: 50%;
}

.main .right .right-content .right-content-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.main .right .right-content .right-bottom-content {
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  height: 35vh;
}

.main .right .right-content .right-bottom-content .right-bottom-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  color: #fff;
  padding: 20px 0;
  border-bottom: 1px rgb(55, 51, 51) dotted;
}

.right-top-item {
  box-sizing: border-box;
}
.right-top-item-title {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.right-top-item-title img {
  width: 60px;
  height: 60px;
  margin-right: 5px;
}
.right-top-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 10px;
  font-size: 30px;
}
.middle {
  flex: 1;
  height: 75vh;
}
.middle-content {
  padding: 20px;
  padding-bottom: unset;
  /* height: 30%;
  box-sizing: border-box; */
}
.middle-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
}
.middle-content .middle-top-box {
  display: flex;
  justify-content: space-between;
  color: #fff;
  /* padding-top: 30px;
  margin-bottom: 30px; */
}
.middle-content .middle-top-box .top-box-item {
  width: 50%;
}
.middle-content .middle-top-box .top-box-item .item-title {
  display: flex;
  align-items: center;
  font-size: 26px;
}
.middle-content .middle-top-box .top-box-item .item-title img {
  width: 60px;
  height: 60px;
}
.middle-content .middle-top-box .top-box-item .item-content {
  display: flex;
  flex-wrap: wrap;
}
.middle-content .middle-top-box .top-box-item .item-content .item {
  width: 50%;
  font-size: 34px;
  margin-top: 10px;
}
.middle-content .middle-top-box .top-box-item .item-content .itemspan {
  font-size: 22px;
}
.middle-center-box {
  padding: 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 26vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
.middle-center-box .middle-center-item {
  width: 30%;
  margin-right: 3%;
  margin-bottom: 1%;
}
.middle-center-box .middle-center-item .title {
  font-size: 28px;
  color: #51b5fd;
  margin-bottom: 10px;
}
.middle-center-box .middle-center-item .info {
  /* background: black; */
  color: #fff;
  width: 100%;
  border-radius: 10px;
}
.middle-center-box .middle-center-item .info > div {
  display: flex;
  text-align: center;
  padding: 10px;
  font-size: 20px;
}
.middle-center-box .middle-center-item .info > div > div {
  width: 33%;
}
.middle-bottom-box {
  display: flex;
  align-items: center;
}
.middle-bottom-box .bottom-item {
  width: 33%;
  text-align: center;
  font-size: 28px;
  color: #fff;
}
.middle-bottom-box .bottom-item .title {
  margin-bottom: 20px;
}
.right-box {
  display: flex;
  align-items: center;
}
.right-box .right-box-item {
  width: 33%;
  text-align: center;
  font-size: 28px;
  color: #fff;
}
.right-table {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
  box-sizing: border-box;
}
.right-table-item {
  display: flex;
  justify-content: space-between;
  padding: 5px;
  box-sizing: border-box;
  color: #fff;
  border-bottom: 1px solid #fff;
}
.right-table-item div:last-child {
  width: 30%;
}
.middle-bottom-box .bottom-item .title {
  margin-bottom: 20px;
}
/* .right-box{ */
/* echarts */
/* 汽废左侧饼图 */
.left-echarts-1,
.left-echarts-2 {
  width: 100%;
  height: 80%;
}
.center-echarts-1 {
  width: 100%;
  height: 20vh;
}
.right-echarts-1 {
  width: 100%;
  height: 70%;
}
.right-echarts-2 {
  width: 100%;
  height: 90%;
}
::v-deep .el-range-input {
  background: transparent !important;
}
::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-input {
  color: #fff !important;
  width: 100px !important;
}
::v-deep .el-date-editor {
  width: 220px;
  padding: unset;
  box-sizing: border-box;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: unset !important;
}
::v-deep .el-date-editor .el-range__icon {
  display: none !important;
}
</style>
  